/**
 * @generated SignedSource<<3844c1247b206e9ebbdf8b64c988e8d3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Appropriateness = "APPROPRIATE" | "NOT_APPROPRIATE" | "NOT_EXPERIENCED" | "UNKNOWN";
export type CompliancePolicy = "SHARIA" | "STANDARD";
export type UserLanguage = "AR" | "DE" | "EN" | "ES" | "FR" | "IT" | "PL" | "TR";
export type OnboardUserInput = {
  aml?: ReadonlyArray<UserAML> | null | undefined;
  clientCategorization?: ReadonlyArray<UserClientCategorization> | null | undefined;
  dac8?: ReadonlyArray<UserDac8> | null | undefined;
  fatca?: ReadonlyArray<UserFatca> | null | undefined;
  tax?: ReadonlyArray<UserTax> | null | undefined;
  termsAndConditions?: ReadonlyArray<string> | null | undefined;
};
export type UserAML = {
  answerId: string;
  questionId: string;
  value?: string | null | undefined;
};
export type UserFatca = {
  answerId: string;
  answerValue?: string | null | undefined;
  questionId: string;
};
export type UserDac8 = {
  answerId: string;
  answerValue?: string | null | undefined;
  countryCode: string;
  questionId: string;
};
export type UserTax = {
  residenceCountry: string;
  tin: string;
};
export type UserClientCategorization = {
  answerId: string;
  answerValue?: string | null | undefined;
  questionId: string;
};
export type OnboardUserMutation$variables = {
  input?: OnboardUserInput | null | undefined;
};
export type OnboardUserMutation$data = {
  readonly onboardUser: {
    readonly accountLevelId?: string | null | undefined;
    readonly active?: boolean;
    readonly appropriateness?: Appropriateness | null | undefined;
    readonly appropriatenessRequiresTestCompletion?: boolean | null | undefined;
    readonly appropriatenessRequiresTestResubmission?: boolean | null | undefined;
    readonly blacklisted?: boolean;
    readonly compliancePolicy?: CompliancePolicy | null | undefined;
    readonly hasTermsNotAccepted: boolean;
    readonly id: string;
    readonly language: UserLanguage;
    readonly onboarded: boolean;
    readonly providerActivated?: boolean;
    readonly tradingActive?: boolean;
    readonly tradingDisabledReason?: string | null | undefined;
    readonly verificationReason?: string | null | undefined;
    readonly verificationStatus?: string;
    readonly verified?: boolean;
  } | null | undefined;
};
export type OnboardUserMutation = {
  response: OnboardUserMutation$data;
  variables: OnboardUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onboarded",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasTermsNotAccepted",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "providerActivated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appropriateness",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appropriatenessRequiresTestCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appropriatenessRequiresTestResubmission",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blacklisted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verificationStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verificationReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountLevelId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tradingActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tradingDisabledReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compliancePolicy",
      "storageKey": null
    }
  ],
  "type": "IndividualUser",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "onboardUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OnboardUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "onboardUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c58af630ce3df0660086db0a08e79930",
    "id": null,
    "metadata": {},
    "name": "OnboardUserMutation",
    "operationKind": "mutation",
    "text": "mutation OnboardUserMutation(\n  $input: OnboardUserInput\n) {\n  onboardUser(input: $input) {\n    __typename\n    id\n    onboarded\n    language\n    hasTermsNotAccepted\n    ... on IndividualUser {\n      providerActivated\n      appropriateness\n      appropriatenessRequiresTestCompletion\n      appropriatenessRequiresTestResubmission\n      active\n      blacklisted\n      verified\n      verificationStatus\n      verificationReason\n      accountLevelId\n      tradingActive\n      tradingDisabledReason\n      compliancePolicy\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f8f9f3f51d3164582c4e318587a21b6";

export default node;
